<div class="row">
  <div class="col-lg-4 d-flex align-items-center">
    <div class="progress-circle-chart mx-auto">
      <app-progress-circle [classref]="'.viewability-progress-circle-chart'" [reverse]="true" [max]="100"
        [overridecolor]="'#3CC778'" [icon]="'&#x2713;'"
        [value]="data?.viewabilityDistribution?.nonGivtSivtViewability * 100">
        <div class="viewability-progress-circle-chart" style="width: 214px; height: 214px; margin:auto;"></div>
      </app-progress-circle>
      <div class="graph-legend progress-circle">
        <div class="big-number color-L" enAnonLock>
          {{data?.viewabilityDistribution?.nonGivtSivtViewability | perc:'1.2-2'}}
        </div>
        <div class="desc-text color-L">
          Average
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-8">
    <ng-container *ngIf="!isFreemium">
      <app-line-chart [data]="lineChartData" [valueAxisUnit]="'%'" [usePrefixes]="false" [height]="'400px'"
        [hideLegend]="true" [categoryField]="'month'" [valueFields]="['nonGivtSivtViewability']"
        [titleArray]="['Viewability']"></app-line-chart>
    </ng-container>
    <div class="container-fluid pl-0 info-list has-info-icon graph-placeholder" *ngIf="isFreemium">
      <div class="freemium-lock">
        <i class="fa fa-lock"></i>
      </div>
    </div>
  </div>
</div>
<div class="row mt-32px">
  <div class="col-lg-12">
    <ng-container>
      <app-data-table-component [headers]="headers" [currentSort]="'totalInventoryRatio'" [data]="adSizes">
      </app-data-table-component>
    </ng-container>
  </div>
</div>

<ng-template #lockedTemplate>
  <i class="fa fa-lock"></i>
</ng-template>